import React from 'react';
import Loadable from 'react-loadable';
import Loading from 'components/Loading';

const AuthFunctionLoadable = Loadable({
  loader: () => import('./AuthFunction')
    .then(module => module.default)
    .catch(() => { if (window) window.location.reload(); }),
  loading: () => <div key="AuthFunctionLoadable"><Loading /></div>
});

export default AuthFunctionLoadable;
